<!-- 公告 TopBanner -->
<template>
  <div class="notice-wrap" :class="{ 'electron-notice-wrap': isElectron }" v-if="isVisible && noticeList.length">
    <div class="notice-container" :class="{ 'notice-container--compact': isScrolled }" :style="noticeStyle">
      <div class="notice-inner">
        <!-- Center Content - Ticker -->
        <div class="notice-ticker">
          <div
            class="notice-ticker__content"
            :class="isAnimating ? 'notice-ticker__content--exit' : 'notice-ticker__content--enter'"
            @mouseenter="stopAutoplay"
            @mouseleave="startAutoplay"
          >
            <span class="notice-tag">
              <svg class="notice-tag__icon" width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              热门推荐
            </span>
            <span
              class="notice-title"
              :class="{ 'notice-title--clickable': currentItem && currentItem.href_type != 1 }"
              @click="jumpUrl(currentItem)"
            >
              {{ currentItem ? currentItem.title : '' }}
            </span>
            <span class="notice-dot"></span>
            <span class="notice-org" v-if="currentItem && currentItem.org_name">
              {{ currentItem.org_name }}
            </span>
            <a
              v-if="currentItem && currentItem.href_type != 1"
              class="notice-cta"
              href="javascript:;"
              @click="jumpUrl(currentItem)"
            >
              立即查看
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14m-7-7 7 7-7 7"/></svg>
            </a>
          </div>
        </div>

        <!-- Close Button -->
        <button
          class="notice-close"
          @click="handleClose"
          aria-label="关闭"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
    </div>
    <!-- 占位 -->
    <div class="placeholder-ele" :style="placeholderStyle"></div>
  </div>
</template>

<script>
import { isMobile, isH5 } from "@saas/components/src";
export default {
  props: {
    noticeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isMobile: isMobile(),
      isH5: isH5(),
      isElectron: window.isElectron,
      isVisible: true,
      currentIndex: 0,
      isAnimating: false,
      timer: null,
      isScrolled: false,
    };
  },
  computed: {
    currentItem() {
      return this.noticeList[this.currentIndex] || null;
    },
    noticeHeight() {
      return this.isScrolled ? 32 : 40;
    },
    noticeStyle() {
      if (this.isH5) {
        // H5: 紧贴在 search-wrap + open-app 下方，使用 CSS 变量动态跟随
        return {
          top: 'calc(var(--h5-search-height, 0px) + var(--h5-open-app-height, 0px))'
        };
      }
      if (this.isElectron) {
        // Electron: 没有网页版 NavBar，紧贴顶部
        return { top: '60px' };
      }
      // PC: 跟随 NavBar 高度（滚动后缩小）
      return { top: this.isScrolled ? '80px' : '96px' };
    },
    placeholderStyle() {
      return { height: this.noticeHeight + 'px' };
    },
  },
  watch: {
    noticeList: {
      handler(val) {
        if (val && val.length > 1) {
          this.startAutoplay();
        }
      },
      immediate: true,
    },
    noticeHeight(val) {
      if (this.isVisible && this.noticeList.length) {
        this.setNoticeHeightVar(val);
      }
    },
  },
  beforeDestroy() {
    this.stopAutoplay();
    window.removeEventListener("scroll", this.handleScroll);
    // 清除 CSS 变量
    this.setNoticeHeightVar(0);
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    this.setNoticeHeightVar(this.noticeHeight);
  },
  methods: {
    jumpUrl(item) {
      if (!item) return;
      if (item.href_type === 2) {
        if (window.isElectron) {
          window.openUrlByExternal(item.href);
        } else {
          window.open(item.href);
        }
      } else if (item.href_type === 3) {
        let url = `/details/${item.id}`;
        if (window.isElectron || this.isMobile) {
          this.$router.push(url);
        } else {
          window.open(url);
        }
      }
    },
    handleClose() {
      this.isVisible = false;
      this.stopAutoplay();
      this.setNoticeHeightVar(0);
    },
    startAutoplay() {
      if (this.timer) return;
      if (!this.noticeList || this.noticeList.length <= 1) return;
      this.timer = setInterval(() => {
        this.isAnimating = true;
        setTimeout(() => {
          this.currentIndex = (this.currentIndex + 1) % this.noticeList.length;
          this.isAnimating = false;
        }, 500);
      }, 4000);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
    setNoticeHeightVar(height) {
      document.body.style.setProperty('--notice-height', height + 'px');
    },
  },
};
</script>

<style lang="scss" scoped>
.electron-notice-wrap.notice-wrap {
  .notice-container {
    left: $side-bar-width;
    width: calc(100% - #{$side-bar-width});
  }
}

.notice-wrap {
  .notice-container {
    width: 100%;
    position: fixed;
    z-index: 100;
    background: rgb(15 23 42); // bg-slate-900
    border-bottom: 1px solid rgb(30 41 59); // border-slate-800
    height: 40px;
    overflow: hidden;
    transition: height 0.3s ease, top 0.3s ease;

    &.notice-container--compact {
      height: 32px;
    }
  }

  .notice-inner {
    max-width: 1280px;
    height: 100%;
    margin: 0 auto;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .notice-ticker {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: 100%;
    position: relative;
  }

  .notice-ticker__content {
    display: flex;
    align-items: center;
    gap: 8px;
    position: absolute;
    width: 100%;
    justify-content: center;
    transition: all 500ms ease;
    transform: translateY(0);
    opacity: 1;

    &--exit {
      transform: translateY(-100%);
      opacity: 0;
    }

    &--enter {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .notice-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: rgb(52 211 153); // text-brand-400
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    font-size: 10px;
    background: rgba(6 78 59 / 0.5); // bg-brand-900/50
    padding: 2px 8px;
    border-radius: 9999px;
    border: 1px solid rgba(16 185 129 / 0.2); // border-brand-500/20
    white-space: nowrap;
    flex-shrink: 0;
  }

  .notice-tag__icon {
    flex-shrink: 0;
  }

  .notice-title {
    color: rgb(241 245 249); // text-slate-100
    font-weight: 500;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;

    &--clickable {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .notice-dot {
    display: none;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgb(71 85 105); // bg-slate-600
    flex-shrink: 0;

    @media (min-width: 768px) {
      display: inline-block;
    }
  }

  .notice-org {
    display: none;
    font-size: 12px;
    color: rgb(148 163 184); // text-slate-400

    @media (min-width: 768px) {
      display: inline;
    }
  }

  .notice-cta {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: white;
    font-weight: 700;
    font-size: 12px;
    margin-left: 4px;
    transition: color 200ms;
    text-decoration: none;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
      color: rgb(52 211 153); // text-brand-400
    }

    svg {
      transition: transform 200ms;
    }

    &:hover svg {
      transform: translateX(2px);
    }

    @media (min-width: 640px) {
      margin-left: 8px;
    }
  }

  .notice-close {
    padding: 6px;
    border-radius: 9999px;
    border: none;
    background: transparent;
    color: rgb(100 116 139); // text-slate-500
    cursor: pointer;
    transition: all 200ms;
    z-index: 10;
    flex-shrink: 0;

    &:hover {
      background: rgba(255 255 255 / 0.1);
      color: white;
    }
  }

  .placeholder-ele {
    height: 40px;
    width: 100%;
  }
}

@media (max-width: 640px) {
  .notice-wrap .notice-title {
    max-width: 140px;
  }
}
</style>
